import { useEffect, useState } from "react";
import { api } from "../api";
import Layout from "../components/Layout";
import { useNavigate } from "react-router-dom";
import { onDataChanged } from "../services/socketService";

export default function CoordinatorDashboard() {

  const [summary, setSummary] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    fetchSummary();
  }, []);

  useEffect(() => {
    const unsubscribe = onDataChanged(() => {
      fetchSummary();
    });

    return () => unsubscribe();
  }, []);

  async function fetchSummary() {
    const response = await api.get("/followups/summary");
    setSummary(response.data);
  }

  if (!summary) return <Layout>Carregando...</Layout>;

  const steps = [
    { key: "STEP_1_STUDENT_WPP", label: "WhatsApp Aluno" },
    { key: "STEP_2_RESPONSIBLE_WPP", label: "WhatsApp Responsável" },
    { key: "STEP_3_SCHOOL_CONTACT", label: "Contato Escola" },
    { key: "STEP_4_HOME_VISIT", label: "Visita Domiciliar" }
  ];

  return (
    <Layout>
      <div className="d-flex justify-content-between align-items-center mb-4">
        <div>
          <h4 className="mb-1">Dashboard de Acompanhamento</h4>
          <small className="text-muted">Visão geral dos casos em andamento</small>
        </div>
      </div>

      <div className="kpi-grid mb-4">
        <div className="kpi-card">
          <div className="kpi-title">Total em Acompanhamento</div>
          <div className="kpi-value kpi-accent">{summary.total}</div>
        </div>
      </div>

      <div className="kpi-grid">
        {steps.map((step) => (
          <div
            key={step.key}
            className="kpi-card"
            role="button"
            tabIndex={0}
            onClick={() => navigate(`/coordinator/kanban/${step.key}`)}
            onKeyDown={(e) => {
              if (e.key === "Enter") navigate(`/coordinator/kanban/${step.key}`);
            }}
          >
            <div className="kpi-title">{step.label}</div>
            <div className="kpi-value">{summary.steps[step.key]}</div>
          </div>
        ))}
      </div>
    </Layout>
  );
}
